import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Checkbox, Col, Form, Input, Row } from "antd";

import PerfilContext from "../../store/perfil-context";
import { required } from "../../services/forms";
import { modalError, modalSuccess } from "../../services/notifications";
import { actions, hasPermission, getToken } from "../../services/security";
import PerfilesModuloList from "./perfiles-modulo-list";
import { BASEURL } from "../../services/url";
import http from "../../services/http";
import MasterDocPerfil from "./perfiles-master-doc";

const PerfilesForm = (props) => {
  let navigate = useNavigate();
  const [form] = Form.useForm();

  const context = useContext(PerfilContext);
  const [checkedValue, setCheckValue] = useState(false);
  const [restricciones, setRestricciones] = useState([]);
  const [documentosRestriccion, setDocumentosRestriccion] = useState([]);
  const [dataCodMasterDoc, setDataCodMasterDoc] = useState([]);
  const [acciones, setAcciones] = useState([]);

  const { id } = props;

  const disabled =
    id === "nuevo"
      ? !hasPermission(actions.PerfilesCrear)
      : !hasPermission(actions.PerfilesEditar);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function getForm() {
      let modulos = [];

      let response = await http.get(`${BASEURL}/Accion/modulo`);

      if (response) {
        const data = response.data;
        for (let i = 0; i < data.length; i++) {
          for (let j = 0; j < data[i].acciones.length; j++) {
            data[i].acciones[j].nombre =
              data[i].acciones[j].nombre.split("-")[1];
          }
        }
        modulos = data;
      }

      response = await http.get(`${BASEURL}/restricciones`);
      if (response) {
        let data = response.data;
        setRestricciones(data);
      }

      response = await http
        .get(`${BASEURL}/perfiles/codMasterDoc`)
        .catch((err) => {
          console.log(err);
        });

      if (response) {
        const data = response.data;
        setDataCodMasterDoc(data);
      }

      if (id === "nuevo") {
        context.updateModulos(modulos, []);
        return;
      }

      response = await http.get(`${BASEURL}/perfiles/${id}`);

      if (response) {
        let dato = response.data;

        form.setFieldsValue(dato);

        context.updateModulos(modulos, dato.acciones);
        setCheckValue(dato.restricciones.length <= 0 ? false : true);
        setAcciones(dato.restricciones);
      }
    }
    getForm();
  }, [id]);

  const onClickBack = () => {
    navigate("/perfiles");
  };

  const onClickSave = async (values) => {
    setLoading(true);

    values.acciones = context.getSelected();

    let json = {
      ...values,
      perfilesDocumento: documentosRestriccion.map((item) => {
        return {
          codMasterDoc: item.codMasterDoc,
          restricciones: checkedValue ? item.acciones : [],
        };
      }),
    };
    const response =
      id === "nuevo"
        ? await http.post(`${BASEURL}/perfiles`, json).catch((error) => {
            if (error.response) {
              modalError(error.response.data.errores[0].titulo);
            }
          })
        : await http.put(`${BASEURL}/perfiles/${id}`, json).catch((error) => {
            if (error.response) {
              modalError(error.response.data.errores[0].titulo);
            }
          });

    setLoading(false);

    if (response) {
      await modalSuccess(
        "Perfil guardado",
        id === "nuevo"
          ? "El perfil fue creado exitosamente"
          : "El perfil fue modificado exitosamente"
      );
      navigate("/perfiles");
    }
  };

  const onChangeCheck = (e) => {
    if (e.target.checked) {
      setCheckValue(true);
    } else {
      setCheckValue(false);
    }
  };

  const handleDocumentosRestriccion = (datos) => {
    setDocumentosRestriccion(datos);
  };

  return (
    <Form layout="vertical" form={form} onFinish={onClickSave}>
      <Row gutter={16}>
        <Col xs={24}>
          <Form.Item label="Nombre" name="nombre" rules={[required]}>
            <Input autoComplete="off" disabled={disabled} />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <label className="form-label" title="Acciones">
            Acciones
          </label>
          <PerfilesModuloList items={context.modulos} disabled={disabled} />
        </Col>

        <Col xs={24}>
          <Checkbox onChange={onChangeCheck} checked={checkedValue}>
            <span className="form-label" title="Restringir por documento">
              Restricción por documento
            </span>
          </Checkbox>
        </Col>

        {checkedValue && (
          <Col xs={24}>
            <MasterDocPerfil
              documentosList={dataCodMasterDoc}
              setDocumentosRestriccion={handleDocumentosRestriccion}
              restricciones={restricciones}
              accionesById={acciones}
            />
          </Col>
        )}
      </Row>

      <div className="actions">
        <Button type="text" onClick={onClickBack}>
          Volver
        </Button>
        {!disabled && (
          <Button type="primary" htmlType="submit" loading={loading}>
            {!loading && "Guardar"}
          </Button>
        )}
      </div>
    </Form>
  );
};

export default PerfilesForm;
